import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useVendorsStore } from "../../store/vendors.store";

export const useVendors = () => {
  const setVendors = useVendorsStore((state) => state.setVendors);

  return useMutation(PartnerApi.vendors, {
    onSuccess: (data) => {
      setVendors(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useVendorsWarehouseSale = () => {
  const setVendors = useVendorsStore((state) => state.setVendors);

  return useMutation(PartnerApi.vendorsWarehouseSale, {
    onSuccess: (data) => {
      setVendors(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
